import { CustomNotification } from 'common/components';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getMemberRoleList } from 'services/roles-security';

export const getKeyMemberRoleList = () => {
  return ['member-role-list'];
};

export const useGetMemberRoleList = (otherOptions) => {
  const queryClient = useQueryClient();

  const queries = useQuery({
    queryKey: getKeyMemberRoleList(),
    queryFn: async () => {
      const response = await getMemberRoleList();

      if (response?.isSuccess) {
        return response?.data;
      }
      CustomNotification.error(response?.message ?? 'Something went wrong');
    },
    retry: 1,
    ...otherOptions,
  });

  const handleRefetchMemberRoleList = () => {
    queryClient.invalidateQueries({
      queryKey: getKeyMemberRoleList(),
    });
  };

  return {
    memberRoleList: queries?.data?.memberRoles ?? [],
    handleRefetchMemberRoleList,
    ...queries,
  };
};
